import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

// services
import Staff from "services/staff/Staff"
import ApplicationService from "../../services/applications/Application.service"

const staffService = new Staff()


const SidebarContent = props => {
  const ref = useRef()
  const user = JSON.parse(localStorage.getItem("authUser"))

  // console.log("user ", user)

  const [permissions, setpermissions] = useState([])
  const [isAdmin, setisAdmin] = useState(false)
  const [isOfficer, setisOfficer] = useState(false)
  const [isHoD, setisHoD] = useState(false)
  const [isDG, setisDG] = useState(false)
  const [mounted, setmounted] = useState(false)
  const [hodRoutes, sethodRoutes] = useState()
  const [pendingApplications, setPendingApplications] = useState()

  let appService = null

  useEffect(() => {
    

    if (user.position_id === 1) {
      setisOfficer(true)
    } else if (user.position_id === 2) {
      setisHoD(true)
    } else if (user.position_id === 3) {
      setisDG(true)
    }

    appService = new ApplicationService(user)

    appService.getStatistics().then(response => {
      setPendingApplications(response.data.pending_applications)
      // console.log("Pending Applications", response.data.pending_applications)
    })
    staffService.getStaffDetails(user).then(response => {
      if (response.status) {
        var perms = []

        response.data.permissions.forEach(perm => {
          perms.push(perm.name)
        })
        setpermissions(perms)
        if (perms.includes("Administer Portal")) {
          setisAdmin(true)
        }
        setmounted(true)
      }
    })
  }, [])

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="ti-home" style={{ color: "cyan" }}></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            {user.department_id == 1 || user.position_id == 3 ? (
              <li>
                <Link to="/env-compliance-dashboard" className="waves-effect">
                  <i className="ti-view-grid" style={{ color: "cyan" }}></i>
                  <span>{props.t("DECE Services")}</span>
                </Link>
              </li>
            ) : null}

            {isHoD ? (
              <li>
                <Link to="/officer-reviewed" className=" waves-effect">
                  <i className="fa fa-tasks" style={{ color: "blue" }}></i>
                  <span>
                    {props.t("DM Pending Apps")}{" "}
                    <span className="badge-success" style={{}}>
                      ({pendingApplications})
                    </span>{" "}
                  </span>
                </Link>
                <Link to="/hod-processing" className=" waves-effect">
                  <i className="fa fa-rocket" style={{ color: "pink" }}></i>
                  <span>{props.t("Processing")}</span>
                </Link>
                <Link to="/hod-returned" className=" waves-effect">
                  <i
                    className="fa fa-arrow-left"
                    style={{ color: "yellow" }}
                  ></i>
                  <span>{props.t("Returned by DG")}</span>
                </Link>

                <Link to="/hod-rejected" className=" waves-effect">
                  <i
                    className="fa fa-times-circle"
                    style={{ color: "red" }}
                  ></i>
                  <span>{props.t("Rejected")}</span>
                </Link>
                <Link to="/hod-approved" className=" waves-effect">
                  <i className="ti-check"></i>
                  <span>{props.t("Approved")}</span>
                </Link>

                <Link to="/hod-reports" className=" waves-effect">
                  <i className="ti-book"></i>
                  <span>{props.t("Reports")}</span>
                </Link>

                <Link to="/companies" className=" waves-effect">
                  <i className="fa fa-building"></i>
                  <span>{props.t("Companies")}</span>
                </Link>

                <Link to="/env-checklist" className=" waves-effect">
                  <i className="fa fa-file" style={{ color: "blue" }}></i>
                  <span>{props.t("Checklist Questions")}</span>
                </Link>

                <Link to="/env-activity-sector" className=" waves-effect">
                  <i className="fa fa-file" style={{ color: "blue" }}></i>
                  <span>{props.t("Sector of Activity")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            {isOfficer ? (
              <li>
                <Link to="/officer-assigned" className=" waves-effect">
                  <i className="fa fa-tasks" style={{ color: "blue" }}></i>
                  <span>{props.t("Reviewed")}</span>
                </Link>
                <Link to="/officer-processing" className=" waves-effect">
                  <i className="fa fa-rocket" style={{ color: "pink" }}></i>
                  <span>{props.t("Processing")}</span>
                </Link>
                <Link to="/officer-returned" className=" waves-effect">
                  <i
                    className="fa fa-arrow-left"
                    style={{ color: "yellow" }}
                  ></i>
                  <span>{props.t("Returned")}</span>
                </Link>
                <Link to="/officer-rejected" className=" waves-effect">
                  <i
                    className="fa fa-times-circle"
                    style={{ color: "red" }}
                  ></i>
                  <span>{props.t("Rejected")}</span>
                </Link>
                <Link to="/officer-approved" className=" waves-effect">
                  <i className="ti-check" style={{ color: "green" }}></i>
                  <span>{props.t("Approved")}</span>
                </Link>
                <Link to="/manual-applications" className=" waves-effect">
                  <i className="ti-pencil-alt" style={{ color: "gray" }}></i>
                  <span>{props.t("Manual Applications")}</span>
                </Link>
              </li>
            ) : null}

            {isDG ? (
              <li>
                <Link to="/dg-approved" className=" waves-effect">
                  <i className="ti-check"></i>
                  <span>{props.t("Approved")}</span>
                </Link>
                <Link to="/dg-rejected" className=" waves-effect">
                  <i
                    className="fa fa-times-circle"
                    style={{ color: "red" }}
                  ></i>
                  <span>{props.t("Rejected")}</span>
                </Link>
              </li>
            ) : null}
            <li>
              <Link to="/all-applications" className=" waves-effect">
                <i className="ti-world" style={{ color: "purple" }}></i>
                <span>{props.t("All Applications")}</span>
              </Link>
            </li>
            {isAdmin ? (
              <li>
                <Link to="/staff" className=" waves-effect">
                  <i className="fa fa-users"></i>
                  <span>{props.t("Manage Staff")}</span>
                </Link>

                <Link to="/configurations" className=" waves-effect">
                  <i className="ti ti-settings"></i>
                  <span>{props.t("Configurations")}</span>
                </Link>
              </li>
            ) : null}

            {/* Messaging */}
            {!isOfficer ? (
              <li>
                <Link to="/messaging" className=" waves-effect">
                  <i className="fa fa-envelope"></i>
                  <span>{props.t("Message Clients")}</span>
                </Link>
              </li>
            ) : null}

            {!isOfficer ? (
              <li>
                <Link to="/plastics-stats" className=" waves-effect">
                  <i className="ti-bar-chart" style={{ color: "brown" }}></i>
                  <span>{props.t("Stats")}</span>
                </Link>
              </li>
            ) : null}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
